var map = {
	"./other_feature_icon_f1.svg": 3532,
	"./other_feature_icon_f2.svg": 2559,
	"./other_feature_icon_f3.svg": 7918,
	"./other_feature_icon_f4.svg": 9473,
	"./other_feature_icon_f5.svg": 5088,
	"./other_feature_icon_f6.svg": 6099
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2033;